type CloseCircleNativeIconProps = React.SVGProps<SVGSVGElement>;

const CloseCircleNativeIcon: React.FC<CloseCircleNativeIconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="close-circle-native-mask"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <path
        d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z"
        fill="white"
      />
    </mask>
    {/* Background (masked to circle) */}
    <rect
      x="0"
      y="0"
      width="16"
      height="16"
      fill="#8E8E8E"
      mask="url(#close-circle-native-mask)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.58586 8L3.29297 4.70711L4.70718 3.29289L8.00008 6.58579L11.293 3.29289L12.7072 4.70711L9.41429 8L12.7072 11.2929L11.293 12.7071L8.00008 9.41421L4.70718 12.7071L3.29297 11.2929L6.58586 8Z"
      fill="white"
    />
  </svg>
);

export default CloseCircleNativeIcon;
